import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody
} from "../../APIHelpers/Responses";

export const formServices = {
  addNewFormTemplate,
  updatedFormTemplate,
  softDeleteRestoreFormTemplate,
  deleteFormTemplate,
  getFormTemplateList,
  getSingleFormTemplate
};

// Add New Form Template
async function addNewFormTemplate(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewFormTemplate`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Form Template
async function updatedFormTemplate(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedFormTemplate`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Soft Delete & Restore Form Template
async function softDeleteRestoreFormTemplate(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreFormTemplate`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Delete Form Template
async function deleteFormTemplate(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteFormTemplate`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get All Form Template
async function getFormTemplateList(status, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getFormTemplateList/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getFormTemplateList/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get All Form Template
async function getSingleFormTemplate(formId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSingleFormTemplate/${formId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}